import type { AuditSummary } from '@expeditor/shared';
import { apiClient } from './client';

export interface AuditFilters {
  fromDate?: string;
  toDate?: string;
  clientId?: string;
}

export const auditApi = {
  summary(): Promise<AuditSummary> {
    return apiClient.get<AuditSummary>('/audit/summary').then((r) => r.data);
  },
  clients() {
    return apiClient.get('/audit/clients').then((r) => r.data);
  },
  registrationEvents(f: AuditFilters = {}) {
    return apiClient.get('/audit/registration-events', { params: f }).then((r) => r.data);
  },
  authEvents(f: AuditFilters & { onlyFailures?: boolean } = {}) {
    const params: Record<string, string> = {};
    if (f.fromDate) params.fromDate = f.fromDate;
    if (f.toDate) params.toDate = f.toDate;
    if (f.onlyFailures) params.onlyFailures = 'true';
    return apiClient.get('/audit/auth-events', { params }).then((r) => r.data);
  },
  profileChanges(f: AuditFilters = {}) {
    return apiClient.get('/audit/profile-changes', { params: f }).then((r) => r.data);
  },
  deregistrations(f: AuditFilters = {}) {
    return apiClient.get('/audit/deregistration-events', { params: f }).then((r) => r.data);
  },
  orders(f: AuditFilters = {}) {
    return apiClient.get('/audit/orders', { params: f }).then((r) => r.data);
  },
  quotes(f: AuditFilters = {}) {
    return apiClient.get('/audit/quotes', { params: f }).then((r) => r.data);
  },
  contracts(f: AuditFilters = {}) {
    return apiClient.get('/audit/contracts', { params: f }).then((r) => r.data);
  },
  contractParties() {
    return apiClient.get('/audit/contract-parties').then((r) => r.data);
  },
  shipments() {
    return apiClient.get('/audit/shipments').then((r) => r.data);
  },
  cargoEvents(f: AuditFilters = {}) {
    return apiClient.get('/audit/cargo-events', { params: f }).then((r) => r.data);
  },
  geoTrack(f: AuditFilters & { shipmentId?: string } = {}) {
    return apiClient.get('/audit/geo-track', { params: f }).then((r) => r.data);
  },
  payments(f: AuditFilters = {}) {
    return apiClient.get('/audit/payments', { params: f }).then((r) => r.data);
  },
  auditLogs(f: AuditFilters & { action?: string } = {}) {
    return apiClient.get('/audit/audit-logs', { params: f }).then((r) => r.data);
  },
};
